import { Component, signal } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.html',
  styleUrl: './activities.scss',
})
export class Activities {
  protected readonly activities: any = environment.ActivitiesConfig;

  // Tracks image URLs that failed to load so we can fall back to the card's icon
  protected readonly brokenImageUrls = signal(new Set<string>());

  protected onImageError(imgUrl: string | null | undefined): void {
    if (!imgUrl) {
      return;
    }

    this.brokenImageUrls.update((urls) => new Set(urls).add(imgUrl));
  }
}
